import { render, staticRenderFns } from "./SeniorSetting.vue?vue&type=template&id=b35ea6f4&scoped=true&"
import script from "./SeniorSetting.vue?vue&type=script&lang=js&"
export * from "./SeniorSetting.vue?vue&type=script&lang=js&"
import style0 from "./SeniorSetting.vue?vue&type=style&index=0&id=b35ea6f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35ea6f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b35ea6f4')) {
      api.createRecord('b35ea6f4', component.options)
    } else {
      api.reload('b35ea6f4', component.options)
    }
    module.hot.accept("./SeniorSetting.vue?vue&type=template&id=b35ea6f4&scoped=true&", function () {
      api.rerender('b35ea6f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/SeniorSetting.vue"
export default component.exports